import { Action, Dispatch } from 'redux';

import { createDataDictionary, sortData } from '../../../utils/dataUtils';
import { getMenu, getNutritionInfo } from '../../api/menu/menu.service';
import {
  Menu,
  NutritionInfo,
  NutritionMenuItem,
} from '../../api/menu/menu.types';
import { Async, AxiosError, Status } from '../../types/data.types';
import {
  NutritionInfoDataDictionary,
  SetMenu,
  SetNutritionInfo,
} from './menu.types';
import { setMenu, setNutritionInfo } from './menuActions';

export const loadMenu =
  (menuUrl: string) =>
  (dispatch: Dispatch<Action>): Promise<void> => {
    const dispatchSetMenu = (menu: Async<Menu>): SetMenu =>
      dispatch(setMenu(menu, menuUrl));

    dispatchSetMenu({ status: Status.LOADING });

    return getMenu(menuUrl)
      .then((data: Menu) => {
        const customData = {
          ...data,
          MenuSections: sortData(data.MenuSections),
        };

        dispatchSetMenu({ status: Status.SUCCESS, data: customData });
      })
      .catch((error: AxiosError) => {
        dispatchSetMenu({ status: Status.ERROR, error });
      });
  };

export const loadNutritionInfo =
  (nutritionInfoUrl: string) =>
  (dispatch: Dispatch<Action>): Promise<void> => {
    const dispatchSetNutritionInfo = (
      nutritionInfo: Async<NutritionInfoDataDictionary>,
    ): SetNutritionInfo =>
      dispatch(setNutritionInfo(nutritionInfo, nutritionInfoUrl));

    dispatchSetNutritionInfo({ status: Status.LOADING });

    return getNutritionInfo(nutritionInfoUrl)
      .then((data: NutritionInfo) => {
        const menuItemsDataDictionary = createDataDictionary<NutritionMenuItem>(
          data?.MenuItems,
          'PublicId',
        );
        const menuItemOptionSetItemsDataDictionary =
          createDataDictionary<NutritionMenuItem>(
            data?.MenuItemOptionSetItems,
            'PublicId',
          );

        const customData = {
          menuItems: menuItemsDataDictionary,
          menuItemOptionSetItems: menuItemOptionSetItemsDataDictionary,
          version: data.Version,
        };

        dispatchSetNutritionInfo({
          status: Status.SUCCESS,
          data: customData,
        });
      })
      .catch((error: AxiosError) => {
        dispatchSetNutritionInfo({ status: Status.ERROR, error });
      });
  };
